import { Grid } from '@mui/material';
import { autobind } from 'core-decorators';
import type React from 'react';
import { Component } from 'react';
import { _ } from '/@/locale';

@autobind
export default class Form extends Component {
    UNSAFE_componentWillMount() {
        this.required = [];

        this.state = {
            ...this.state,
            values: {},
            loading: false,
            shouldValidate: [],
        };

        Object.entries(this.fields).forEach(([key, config]) => {
            if (config.required !== false) this.required.push(key);
            this.state.values[key] = config.initial;
        });

        if (this.shouldValidate) this.state.shouldValidate = this.shouldValidate;
    }

    getFieldProps(key) {
        return {
            value: this.state.values[key],
            error: this.state.shouldValidate.includes(key) && this.hasError(key),
            disabled: this.state.loading,
            onChange: this.handleChange(key),
            onBlur: this.handleBlur(key),
            onKeyDown: this.handleKeyDown,
        };
    }

    hasError(key) {
        if (this.required.includes(key) && !this.state.values[key]) return _('Este campo es requerido.');

        if (this.validation[key]) {
            const result = this.validation[key](this.state.values);
            if (result === true) return false;
            return result;
        }

        return false;
    }

    validate() {
        if (!Object.keys(this.fields).every((field) => this.hasError(field) === false)) return false;
        return true;
    }

    clear(key, value) {
        this.setState((state) => ({
            values: { ...state.values, [key]: value },
            shouldValidate: state.shouldValidate.filter((other) => other !== key),
        }));
    }

    handleChange(key) {
        return (value) => {
            this.setState(
                (state) => ({
                    values: { ...state.values, [key]: value },
                }),
                () => this.handleAfterChange(key)
            );
        };
    }

    handleBlur(key) {
        return () => {
            if (!this.state.shouldValidate.includes(key)) {
                this.setState((state) => ({ shouldValidate: [...state.shouldValidate, key] }));
            }
        };
    }

    handleKeyDown(event) {
        if (event.keyCode === 13 && this.validate()) {
            this.handleSubmit();
        }
    }

    // Subclasses can override these hooks
    handleAfterChange(key) {}
    handleSubmit() {}
}

interface FormMessageProps {
    children: string;
    style: 'error' | 'success';
}

export const FormMessage: React.FC<FormMessageProps> = ({ children, style }) => {
    if (!children) return null;
    return (
        <Grid
            container
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
                color: 'white !important',
                minHeight: '3.2rem',
                px: 2,
                py: 1,
                borderRadius: 1,
                background: (t) => (style === 'error' ? t.palette.warning.main : t.palette.success.main),
            }}
        >
            <Grid item>{children}</Grid>
        </Grid>
    );
};
